import Vue from 'vue';
import { ContentLoader } from 'vue-content-loader' ;
import { Component } from 'vue-property-decorator' ;
import LoaderPalette from '../../../../components/loader-palette';


interface TextBox {
    width: number
    height: number
    radius: number
}

@Component({
    components: {
        ContentLoader
    }
})
class TicketSidebar extends LoaderPalette {

    readonly dtText : TextBox;
    readonly dtHeaderText: TextBox;

    constructor(){
        super()

        this.dtText={
            width: 200,
            height: 15,
            radius: 4
        }

        this.dtHeaderText= {
            width: 200,
            height: 30,
            radius: 3
        }
    }
}

export default TicketSidebar


// WEBPACK FOOTER //
// ./src/containers/ticket/loaders/ticket-sidebar-loader/index.ts